import { call, put, takeEvery, CallEffect, PutEffect } from 'redux-saga/effects'
import { catalogActions } from './actions'
import { batteryService } from '../../../services'

/**
 * Saga para buscar listagem de baterias
 */
function* fetchBatteriesSaga(action: ReturnType<typeof catalogActions.fetchBatteriesRequest>): Generator<CallEffect | PutEffect, void, any> {
  try {
    const filters = action.payload
    const response = yield call(batteryService.list, filters)
    
    yield put(catalogActions.fetchBatteriesSuccess({
      batteries: response.batteries,
      pagination: response.pagination,
      filters: response.filters
    }))
  } catch (error: any) {
    const errorMessage = error.response?.data?.message || error.message || 'Erro ao carregar baterias'
    yield put(catalogActions.fetchBatteriesFailure({ error: errorMessage }))
  }
}

/**
 * Saga para buscar bateria por ID ou slug
 */
function* fetchBatterySaga(action: ReturnType<typeof catalogActions.fetchBatteryRequest>): Generator<CallEffect | PutEffect, void, any> {
  try {
    const { id, slug } = action.payload
    let response
    
    if (id) {
      response = yield call(batteryService.getById, id)
    } else if (slug) {
      response = yield call(batteryService.getBySlug, slug)
    } else {
      yield put(catalogActions.fetchBatteryFailure({ error: 'ID ou slug é obrigatório' }))
      return
    }
    
    const key = id || slug || ''
    yield put(catalogActions.fetchBatterySuccess({
      battery: response.battery,
      key
    }))
  } catch (error: any) {
    const errorMessage = error.response?.data?.message || error.message || 'Erro ao carregar bateria'
    yield put(catalogActions.fetchBatteryFailure({ error: errorMessage }))
  }
}

/**
 * Saga para buscar baterias em destaque
 */
function* fetchFeaturedBatteriesSaga(): Generator<CallEffect | PutEffect, void, any> {
  try {
    const response = yield call(batteryService.getFeatured)
    
    yield put(catalogActions.fetchFeaturedBatteriesSuccess({
      batteries: response.batteries || []
    }))
  } catch (error: any) {
    const errorMessage = error.response?.data?.message || error.message || 'Erro ao carregar baterias em destaque'
    yield put(catalogActions.fetchFeaturedBatteriesFailure({ error: errorMessage }))
  }
}

/**
 * Saga para buscar baterias
 */
function* searchBatteriesSaga(action: ReturnType<typeof catalogActions.searchBatteriesRequest>): Generator<CallEffect | PutEffect, void, any> {
  try {
    const response = yield call(batteryService.search, action.payload)
    
    yield put(catalogActions.searchBatteriesSuccess({
      batteries: response.batteries,
      suggestions: response.suggestions
    }))
  } catch (error: any) {
    const errorMessage = error.response?.data?.message || error.message || 'Erro ao buscar baterias'
    yield put(catalogActions.searchBatteriesFailure({ error: errorMessage }))
  }
}

/**
 * Root saga do módulo Catalog
 */
export function* catalogSaga(): Generator {
  yield takeEvery(catalogActions.fetchBatteriesRequest.type, fetchBatteriesSaga)
  yield takeEvery(catalogActions.fetchBatteryRequest.type, fetchBatterySaga)
  yield takeEvery(catalogActions.fetchFeaturedBatteriesRequest.type, fetchFeaturedBatteriesSaga)
  yield takeEvery(catalogActions.searchBatteriesRequest.type, searchBatteriesSaga)
}

